import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 10px;
`;

export const PartnerSection = styled.div`
  margin-bottom: 20px;
`;

export const PartnerName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.text.primary};
`;

export const ClientList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ClientItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

export const NoClients = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
  color: ${({ theme }) => theme.text.secondary};
`;

export const BlacklistedLabel = styled.span`
  color: #ff4d4d;
  font-size: 14px;
  font-style: italic;
`;

export const ActionButtonContainer = styled.div`
  margin-top: 20px;
  text-align: right;
`;
